import types from 'redux/types';

const checkCredit = (data) => ({ ...data, type: types.REQUEST_CHECK_CREDIT });
const getListOrder = (data) => ({ ...data, type: types.REQUEST_GET_LIST_ORDER });
const createOrder = (data) => ({ ...data, type: types.REQUEST_CREATE_ORDER });

export default {
  checkCredit,
  getListOrder,
  createOrder,
};
